import type { SeoJob } from "../../../services/seo";

const EM_ANDAMENTO: SeoJob["status"][] = ["QUEUED", "CLAIMED", "RUNNING"];

/**
 * Se o job em andamento deve travar o botão desta aba.
 *
 * Um job fica em QUEUED até a extensão do operador puxá-lo, o que pode demorar.
 * Antes, qualquer job em andamento travava a publicação inteira: quem publicava
 * os SERVIÇOS não conseguia publicar os PRODUTOS em seguida e tinha que refazer
 * a seleção toda. Serviços e produtos são filas independentes — cada um só
 * espera o seu.
 */
export const jobBloqueiaEsteModo = (
  job: SeoJob | null | undefined,
  modo: SeoJob["mode"],
): boolean => !!job && job.mode === modo && EM_ANDAMENTO.includes(job.status);
